<template>
  <a :class="['button-back']" @click.prevent="click">
    <div class="button-back-icon">
      <svg
        width="7"
        height="12"
        viewBox="0 0 7 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6 1L1 6L6 11"
          stroke="#DDEDFF"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <div class="back-text">{{ label }}</div>
  </a>
</template>

<script>
export default {
  name: "Back",
  props: {
    go: {
      required: true,
    },
    label: {
      default: "Back",
    },
  },
  data() {
    return {
      audio: null,
    };
  },
  computed: {},
  mounted() {
    // this.audio =
  },
  methods: {
    click() {
      const duration = 0;
      this.$store.commit("setTransitioningBack", true);

      // this.audio.play();

      setTimeout(() => {
        this.$router.push(this.go);
      }, duration);
    },
  },
};
</script>

<style>
.button-back {
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  transition: all 100ms ease-in-out;
  position: relative;
  width: fit-content;
  margin-bottom: 2.4rem;
}

.button-back .back-text {
  font-family: "ISO";
  font-style: normal;
  font-weight: 500;
  font-size: 1.8rem;
  line-height: 150%;
  transition: all 100ms ease-in-out;
  color: #ffffff;
}

.button-back:hover .back-text {
  color: #DDEDFF;
}

.button-back .button-back-icon {
  position: relative;
  top: 0px;
  left: 1px;
  margin-right: 8px;
  transition: all 150ms ease-in-out;
}

.button-back .button-back-icon svg g path {
  transition: all 150ms ease-in-out;
}

.button-back:hover .button-back-icon {
  transform: translate(-0.4rem, 0);
}

.button-back:hover .button-back-icon svg g path {
  /* fill: var(--white-200); */
}
</style>
